/**
 * @module media/multimediaembed
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import MultiMediaEmbedEditing from './multimediaembed/multimediaembedediting';
import MultiMediaEmbedUI from './multimediaembed/multimediaembedui';

export default class MultiMediaEmbed extends Plugin {
	static get requires() {
		return [ MultiMediaEmbedEditing, MultiMediaEmbedUI ];
	}

	static get pluginName() {
		return 'MultiMediaEmbed';
	}
}
